import defaultEnums from '@/config/system-enums'

const state = {
  systemEnum: defaultEnums
}

const getters = {
  getSysEnumTextByValue: (state) => (type, value) => {
    return state.systemEnum[type]?.find((e) => e.value === value)?.text ?? '-'
  },
  getSysEnums: (state) => (type) => {
    return state.systemEnum[type]
  }
}

export default {
  namespaced: true,
  state,
  getters
}
